import { updateObject } from './../../utils/utility';

const initialState = {
    savedReports: [],
    companies: [],
    reportData: false,
    hasServerResponded: false,
    reportList: [],
    companyList: [],
    countryList: [],
    legalEntityList: [],
    selectedOrderId: null
};

const setReportsData = (state = initialState, action) => {
    const { orderList = [], totalElements, pageNumber, totalPages, companyList = [], countryList = [], legalEntityList = [] } = action.payload;
    return updateObject(state, {
        reportList: orderList && orderList.length ? orderList : [],
        totalElements,
        pageNumber,
        totalPages,
        companyList,
        countryList,
        legalEntityList
    });
}

const setHasResponded = (state = initialState, action) => {
    return updateObject(state, {
        hasServerResponded: action.data,
    });
};

const setReports = (state = initialState, action) => {
    return updateObject(state, {
        savedReports: action.data
    });
};
const setReportData = (state = initialState, action) => {
    return updateObject(state, {
        reportData: action.data
    });
};

const setCompanies = (state = initialState, action) => {
    return updateObject(state, {
        companies: action.data,
    });
};

const setCheckBoxSelectionForSpecificReport = (state = initialState, action) => {
    let { value, reportType, orderId } = action;
    const { reportList } = state;
    const selectedOrderReport = reportList.find(report => report.orderId === orderId);
    const selectedOrderReportIndex = reportList.findIndex(report => report.orderId === orderId);
    if (selectedOrderReport) {
        selectedOrderReport[reportType] = value;
        reportList[selectedOrderReportIndex] = selectedOrderReport;
    }
    return updateObject(state, { reportList, selectedOrderId: orderId });
}

const resetCheckBoxSelectionForSpecificReport = (state = initialState) => {
    return updateObject(state, { selectedOrderId: null });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_HAS_REPORTS_RESPONDED") {
        return setHasResponded(state, action);
    }
    else if (action.type === "SET_REPORTS_DATA") {
        return setReports(state, action);
    }
    else if (action.type === "SET_REPORT_DATA") {
        return setReportData(state, action);
    }
    else if (action.type === "SET_REPORTS_COMPANIES") {
        return setCompanies(state, action);
    }
    else if (action.type === "SET_DRS_REPORTS_DATA") {
        return setReportsData(state, action);
    }
    else if (action.type === "SET_CHECKBOX_SELECTION_FOR_SPECIFIC_REPORT") {
        return setCheckBoxSelectionForSpecificReport(state, action);
    }
    else if (action.type === "RESET_CHECKBOX_SELECTION_FOR_SPECIFIC_REPORT") {
        return resetCheckBoxSelectionForSpecificReport(state, action);
    }
    return state;
};

export default reducer;
